import { IcmsStDeterminationMode } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Select, SelectProps } from 'antd';

const options = [
  {
    value: IcmsStDeterminationMode.TABLE_PRICE_MAX,
    label: '0 - Preço tabelado ou máximo sugerido',
  },
  {
    value: IcmsStDeterminationMode.NEGATIVE_LIST,
    label: '1 - Lista Negativa (valor)',
  },
  {
    value: IcmsStDeterminationMode.POSITIVE_LIST,
    label: '2 - Lista Positiva (valor)',
  },
  {
    value: IcmsStDeterminationMode.NEUTRAL_LIST,
    label: '3 - Lista Neutra (valor)',
  },
  {
    value: IcmsStDeterminationMode.MARGIN_VALUE_ADDED,
    label: '4 - Margem Valor Agregado (%)',
  },
  { value: IcmsStDeterminationMode.TABLE_PRICE, label: '5 - Pauta (valor)' },
  {
    value: IcmsStDeterminationMode.OPERATION_VALUE,
    label: '6 - Valor da Operação (NT 2019.001)',
  },
];

const TaxIcmsBcStModalitySelect: React.FC<SelectProps> = (props) => {
  return <Select {...props} options={options} />;
};

export default TaxIcmsBcStModalitySelect;
